import { render, staticRenderFns } from "./ModalBrandMapping.vue?vue&type=template&id=a32c8632"
import script from "./ModalBrandMapping.vue?vue&type=script&lang=js"
export * from "./ModalBrandMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports